@if (showCreateItem) {
  <div>
    <mat-horizontal-stepper [linear]="isLinear">
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup" (ngSubmit)="onSubmit()">
          <ng-template matStepLabel>
            <div>
              <span active>Create your Item/Modifier</span>
            </div>
          </ng-template>
          <table cellspacing="2" class="itemgrouping-modal-full-width">
            <tr>
              <td>
                <mat-form-field>
                  <input
                    [attr.data-testid]="'modifier_tag_text'"
                    formControlName="tag"
                    matInput
                    pattern="^[A-Z_0-9]*$"
                    placeholder="Item/Modifier Tag"
                    required
                    (focusout)="findTagExists()"
                    />
                  @if (firstFormGroup.controls['tag'].invalid && !firstFormGroup.controls['tag'].value) {
                    <mat-error
                      >
                      Please enter a Standard Tag
                    </mat-error>
                  }
                  @if (firstFormGroup.controls['tag'].errors?.pattern && firstFormGroup.controls['tag'].value) {
                    <mat-error
                      >
                      Please enter a Valid Standard Tag
                    </mat-error>
                  }
                  @if (firstFormGroup.controls['tag'].errors?.tagExists && firstFormGroup.controls['tag'].touched) {
                    <mat-error
                      >
                      Tag already exists! Create a new one.
                    </mat-error>
                  }
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <mat-select
                    [attr.data-testid]="'item_type_select'"
                    formControlName="itemType"
                    placeholder="Item Type"
                    required
                    >
                    @for (itemType of itemTypes; track itemType) {
                      <mat-option
                        [attr.data-testid]="itemType.name + '_option'"
                        [value]="itemType.tag"
                      >{{ itemType.name }}</mat-option>
                    }
                  </mat-select>
                  @if (firstFormGroup.controls['itemType'].invalid) {
                    <mat-error>
                      Please Select a Item Type
                    </mat-error>
                  }
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field>
                  <mat-select
                    [attr.data-testid]="'locked_select'"
                    formControlName="locked"
                    matTooltip="This will prevent deletion of the item"
                    placeholder="Locked"
                    >
                    <mat-option [attr.data-testid]="'locked_true_option'" [value]="true">True</mat-option>
                    <mat-option [attr.data-testid]="'locked_false_option'" [value]="false">False</mat-option>
                  </mat-select>
                  @if (firstFormGroup.controls['locked'].invalid) {
                    <mat-error>
                      Please Enter a Locked Value
                    </mat-error>
                  }
                </mat-form-field>
              </td>
            </tr>
          </table>
          <div  style="margin-top: 30px; height: 50px;" class="flex-center-center">
            <button
              [attr.data-testid]="'cancel_button'"
              class="button-color"
              mat-raised-button
              matTooltip="Cancel Creating Item"
              style="margin-right: 60px;"
              type="button"
              (click)="onNoClick()"
              >
              Cancel
            </button>
            <button
              [attr.data-testid]="'submit_button'"
              mat-raised-button
              matStepperNext
              matTooltip="Submit Item"
              type="submit"
              class="button-color"
              >
              Next
            </button>
          </div>
        </form>
      </mat-step>
      @if (globalAttributes) {
        <mat-step [stepControl]="secondFormGroup">
          <form [formGroup]="secondFormGroup" (ngSubmit)="onSubmit2()">
            <ng-template matStepLabel>
              Add Global Attributes to {{ firstFormGroup.controls['tag'].value | uppercase }}
            </ng-template>
            <div  style="height:50vh; overflow: auto; min-height: 400px;" class="flex-row-wrap">
              @for (attribute of globalAttributes; track attribute) {
                <div  class="flex-50">
                  @if (attribute?.type === 'NUM') {
                    <mat-form-field>
                      <input
                        [attr.data-testid]="attribute.name + '_number'"
                        [formControlName]="attribute.tag"
                        matInput type="number"
                        [placeholder]="attribute.name"
                        [required]="attribute.required"
                        (focusout)="numberValidation(attribute.tag)"
                        />
                      @if (secondFormGroup.controls[attribute.tag].invalid) {
                        <mat-error>
                          Please enter a valid value (eg:23.50)
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (attribute?.type==='TEXT') {
                    <mat-form-field>
                      <input
                        [attr.data-testid]="attribute.name + '_text'"
                        [formControlName]="attribute.tag"
                        matInput
                        [placeholder]="attribute.name"
                        type="text"
                        [required]="attribute.required"
                        />
                      @if (secondFormGroup.controls[attribute.tag].invalid && !secondFormGroup.controls[attribute.tag].value) {
                        <mat-error>
                          Please enter a Value
                        </mat-error>
                      }
                      @if (secondFormGroup.getError('invalidWhiteSpace', attribute.tag); as error) {
                        <mat-error >
                          {{ error }}
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (attribute?.type === 'TEXTAREA') {
                    <mat-form-field>
                      <textarea
                        [attr.data-testid]="attribute.name + '_textarea'"
                        [formControlName]="attribute.tag"
                        matInput
                        matAutosizeMaxRows="4"
                        matAutosizeMinRows="1"
                        matTextareaAutosize
                        [placeholder]="attribute.name"
                        [required]="attribute.required"
                      ></textarea>
                      @if (secondFormGroup.controls[attribute.tag].invalid && !secondFormGroup.controls[attribute.tag].value) {
                        <mat-error>
                          Please enter a Value
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (attribute?.type === 'BOOL') {
                    <mat-form-field>
                      <mat-select
                        [attr.data-testid]="attribute.name + '_bool'"
                        [placeholder]="attribute.name"
                        [formControlName]="attribute.tag"
                        [required]="attribute.required"
                        >
                        @if (!attribute.required) {
                          <mat-option
                            [attr.data-testid]="attribute.name + '_option'"
                            [value]=""
                            >
                            (empty)
                          </mat-option>
                        }
                        <!-- Data type changed from string ('true') to boolean (true) -->
                        <mat-option [attr.data-testid]="'true_option'" [value]="true">True</mat-option>
                        <mat-option [attr.data-testid]="'false_option'" [value]="false">False</mat-option>
                      </mat-select>
                      @if (secondFormGroup.controls[attribute.tag].invalid && !secondFormGroup.controls[attribute.tag].value) {
                        <mat-error>
                          Please enter a Value
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (attribute?.type === 'SELECT') {
                    <mat-form-field>
                      <mat-select
                        [attr.data-testid]="attribute.name + '_select'"
                        [formControlName]="attribute.tag"
                        [placeholder]="attribute.name"
                        [required]="attribute.required"
                        >
                        @if (!attribute.required) {
                          <mat-option [value]="">(empty)</mat-option>
                        }
                        @for (globalSelectValue of attribute?.options; track globalSelectValue) {
                          <mat-option
                            [attr.data-testid]="globalSelectValue.label + '_option'"
                            [value]="globalSelectValue.label"
                          >{{ globalSelectValue.label }}</mat-option>
                        }
                      </mat-select>
                      @if (secondFormGroup.controls[attribute.tag].invalid && !secondFormGroup.controls[attribute.tag].value) {
                        <mat-error>
                          Please enter a Value
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (attribute?.type === 'MULTI_SELECT') {
                    <mat-form-field>
                      <mat-select
                        [attr.data-testid]="attribute.name + '_multiselect'"
                        [placeholder]="attribute.name"
                        [formControlName]="attribute.tag"
                        multiple
                        [required]="attribute.required"
                        >
                        @for (topping of attribute.options; track topping) {
                          <mat-option
                            [attr.data-testid]="topping.value + '_option'"
                            [value]="topping.value"
                          >{{ topping.value }}</mat-option>
                        }
                      </mat-select>
                      @if (secondFormGroup.controls[attribute.tag].invalid && !secondFormGroup.controls[attribute.tag].value) {
                        <mat-error>
                          Please enter a Value
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (attribute?.type==='IMAGE') {
                    <mat-form-field>
                      <input
                        [attr.data-testid]="attribute.name + '_image'"
                        [formControlName]="attribute.tag"
                        matInput
                        [placeholder]="attribute.name"
                        type="text"
                        (focusout)="imageValidation(attribute.tag)"
                        />
                      @if (secondFormGroup.controls[attribute.tag].invalid) {
                        <mat-error>
                          Please enter a valid URL
                        </mat-error>
                      }
                      @if (secondFormGroup.getError('invalidWhiteSpace', attribute.tag); as error) {
                        <mat-error >
                          {{ error }}
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                </div>
              }
            </div>
            <div  style="height: 50px; margin-top: 30px;" class="flex-center-center">
              <button
                [attr.data-testid]="'back_button'"
                mat-raised-button
                matStepperPrevious
                matTooltip="Back"
                style="margin-right: 30px;"
                >
                Back
              </button>
              <button
                [attr.data-testid]="'save_button'"
                class="button-color"
                [disabled]="isReadOnly$ | async"
                mat-raised-button
                matStepperNext
                matTooltip="Save Item"
                type="submit"
                >
                Save
              </button>
            </div>
          </form>
        </mat-step>
      }
    </mat-horizontal-stepper>
  </div>
}
